import { Component, Input } from '@angular/core';
import { InteractionPublic } from '../../../../../globalTypes/interactions.types';
import { DatePipe, JsonPipe } from '@angular/common';
import { dateTimeFormat } from '../../../../../globalTypes/base.types';
import { Store } from '@ngrx/store';
import { NameTagComponent } from "./name.tag.component";
import { LocationPublic } from '../../../../../globalTypes/account.types';
import { accountFeature } from '../../../store/account.store';
import { take } from 'rxjs';

@Component({
  selector: 'msh-interaction-entry',
  imports: [DatePipe, NameTagComponent],
  template: `
   <div class="mt-8 mb-12">
    <div class="flex gap-3 mb-3 items-center">
      <div class=" min-w-32 text-xs">{{interaction.createdAt | date:dateTimeFormat}}</div>
      <div class=" font-bold">{{interaction.subject}}</div>
    </div>
    @if(interaction.body){
      <div class="ml-0 md:ml-32 pl-3">{{interaction.body}}</div>
    }
    <div class="ml-0 md:ml-32">
      @if(interaction.buyerInitiated && interaction.buyerId; as locationId){
        <msh-name-tag [imagePosition]="isBuyer ? 'left' : 'right'" [class]="' ml-3 block ' + (isBuyer ? 'mt-3' : '')" size="small" [label]="locations[locationId].name" [url]="locations[locationId].profileImage?.url"></msh-name-tag>
      } @else if(interaction.sellerId) {
        <msh-name-tag [imagePosition]="isBuyer ? 'right' : 'left'" [class]="' ml-3 block ' + (isBuyer ? '' : 'mt-3')" size="small" [label]="locations[interaction.sellerId].name" [url]="locations[interaction.sellerId].profileImage?.url"></msh-name-tag>
      }
    </div>
   </div>
  `,
  styles: ``
})
export class InteractionEntryComponent {
  @Input() interaction!: InteractionPublic
  @Input() isBuyer!: boolean
  dateTimeFormat = dateTimeFormat;
  locations: {[locationId: string]: LocationPublic} = {};

  constructor(
    private store: Store,
  ){
    this.store.select(accountFeature.selectLocations).pipe(take(1)).subscribe(locations => {
      this.locations = locations;
    })
  }
}
